import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Badge,
  Progress,
} from "reactstrap";

const ChannelStatus = ({
  channels = [],
  syncDashboard = {},
}) => {
  const syncStats = channels.reduce(
    (acc, channel) => {
      [
        channel.syncInventory,
        channel.syncRates,
        channel.syncBookings,
      ].forEach((sync) => {
        acc.total++;

        if (sync) {
          acc.success++;
        } else {
          acc.failed++;
        }
      });

      return acc;
    },
    {
      total: 0,
      success: 0,
      failed: 0,
      pending: 0,
    }
  );

  const totalChannels =
    channels.length;

  const activeChannels =
    channels.filter(
      (c) => c.enabled
    ).length;

  const channelHealth =
    totalChannels > 0
      ? Math.round(
        (activeChannels /
          totalChannels) *
        100
      )
      : 0;

  return (
    <Col xl={4}>
      <Card
        style={{
          height: "100%",
        }}
      >
        <CardHeader>
          <h4 className="card-title mb-0">
            Live Channel Status
          </h4>
        </CardHeader>

        <CardBody>

          {/* Overall Health */}

          <div className="mb-4">

            <div className="d-flex justify-content-between mb-2">
              <span>
                Channel Health
              </span>

              <strong>
                {channelHealth}%
              </strong>
            </div>

            <Progress
              value={
                channelHealth
              }
              color={
                channelHealth >= 80
                  ? "success"
                  : channelHealth >= 50
                    ? "warning"
                    : "danger"
              }
            />

          </div>

          {/* Sync Summary */}

          <div className="border rounded p-3 mb-4">

            <div className="d-flex justify-content-between mb-2">
              <span>
                Total Syncs
              </span>

              <Badge color="primary">
                {syncStats.total}
              </Badge>
            </div>

            <div className="d-flex justify-content-between mb-2">
              <span>
                Success
              </span>

              <Badge color="success">
                {syncStats.success}
              </Badge>
            </div>

            <div className="d-flex justify-content-between mb-2">
              <span>
                Failed
              </span>

              <Badge color="danger">
                {syncStats.failed}
              </Badge>

            </div>

            <div className="d-flex justify-content-between">
              <span>
                Pending
              </span>

              <Badge color="warning">
                {syncStats.pending}
              </Badge>
            </div>

          </div>

          {/* Channel Status */}

          {channels.length === 0 && (
            <div className="text-center text-muted">
              No Channels Connected
            </div>
          )}

          {channels.map(
            (channel) => {

              const status =
                channel.enabled
                  ? "Connected"
                  : "Disconnected";

              return (
                <div
                  key={
                    channel._id
                  }
                  className="d-flex justify-content-between align-items-center border-bottom py-2"
                >

                  <div>

                    <h6 className="mb-0">
                      {
                        channel.channel
                      }
                    </h6>

                    <small className="text-muted">
                      Hotel ID :
                      {" "}
                      {
                        channel.hotelId
                      }
                    </small>

                  </div>

                  <Badge
                    color={
                      channel.enabled
                        ? "success"
                        : "danger"
                    }
                  >
                    {status}
                  </Badge>

                </div>
              );
            }
          )}

        </CardBody>
      </Card>
    </Col>
  );
};

export default ChannelStatus;